import React, { useState } from 'react';
import { __, sprintf } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

// api


// components
import SwitchButton from '../../components/SwitchButton';
import ToggleSwitch from '../../components/ToggleSwitch';
import KnobField from '../../components/KnobField';
import ButtonFlat from '../../components/ButtonWrapper/components/ButtonFlat';
import ButtonFlatAccent from '../../components/ButtonWrapper/components/ButtonFlatAccent';
import ButtonFlatWarning from '../../components/ButtonWrapper/components/ButtonFlatWarning';
import ButtonOutline from '../../components/ButtonWrapper/components/ButtonOutline';
import Button3d from '../../components/ButtonWrapper/components/Button3d';
import DropdownWithSearch from '../../components/DropdownWithSearch';
import PinIcon from '../../icons/PinIcon';
import ButtonIconRadio from '../../components/ButtonWrapper/components/ButtonIconRadio';
import ButtonIconFlat from '../../components/ButtonWrapper/components/ButtonIconFlat';
import HamburgerIcon from '../../icons/HamburgerIcon';
import Badge from '../../components/Badge';
import ButtonFormSubmit from '../../components/ButtonWrapper/components/ButtonFormSubmit';
import FormField from '../../components/FormField';
import FileuploadDropZone from '../../components/FileuploadDropZone';
import SliderField from '../../components/SliderField';
import WorkbenchPanel from '../../components/WorkbenchPanel';
import ButtonIconRadioFlat from '../../components/ButtonWrapper/components/ButtonIconRadioFlat';
import ProjectCard from '../Projects/components/ProjectCard';
import CommCenter from '../../components/CommCenter';
import CommCenterProjects from '../Projects/components/CommCenterProjects';
import { MOCK_BRIEF } from '../../components/CommCenter/mockData';

const addDays = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString().slice(0, 10);
};

const demoProjects = [
    {
        id: 'demo-1',
        title: 'Due spicci',
        status: 'in_progress',
        deadline: addDays(0),
        creationDate: addDays(-1),
        newCommentsCount: 1,
        thumbnailUrl: ''
    },
    {
        id: 'demo-2',
        title: 'Nebbia sul Naviglio',
        status: 'completed',
        deadline: addDays(3),
        creationDate: addDays(-40),
        newCommentsCount: 7,
        thumbnailUrl: ''
    },
    {
        id: 'demo-3',
        title: 'Petali di vetro',
        status: 'waiting_for_review',
        deadline: addDays(14),
        creationDate: addDays(-40),
        thumbnailUrl: ''
    },
    {
        id: 'demo-4',
        title: 'Note da Kyoto — titolo molto lungo che deve essere troncato',
        status: null,
        deadline: addDays(90),
        creationDate: addDays(-2),
        thumbnailUrl: ''
    }
];

const DevComponents = () => {
    const [states, setStates] = useState({
        default: false,
        neutral: false,
        ref: false,
        audio: false,
        btn3d: false,
        btnIcon1: false,
        dropdownWithSearch1: 2,
        dropdownWithSearch2: 1,
        slider1: 75,
        switchDemo1: true,
        switchDemo2: false,
        switchDemo3: true,
        toggleDemo1: false,
        toggleDemo2: true
    });
    const {
        control
    } = useForm({ mode: 'onChange', defaultValues: { switchDemo1: true, switchDemo3: true } });

    const handleToggle = (variant) => {
        setStates(prev => ({
            ...prev,
            [variant]: !prev[variant]
        }));
    };

    const handleSelect = (value, name) => {
        setStates(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div style={{overflowY: 'scroll'}}>
            <div className="demoBox">
                <h2>SwitchButtons</h2>

                <SwitchButton
                    variant="default"
                    checked={states.default}
                    changeFn={() => handleToggle('default')}
                    tooltip="Default variant"
                />

                <SwitchButton
                    variant="neutral"
                    checked={states.neutral}
                    changeFn={() => handleToggle('neutral')}
                    tooltip="Neutral variant"
                />

                <SwitchButton
                    variant="ref"
                    checked={states.ref}
                    changeFn={() => handleToggle('ref')}
                    tooltip="Refe variant"
                />

                <SwitchButton
                    variant="audio"
                    checked={states.audio}
                    changeFn={() => handleToggle('audio')}
                    tooltip="Audio variant"
                />
                <SwitchButton
                    variant="default"
                    checked={false}
                    disabled
                    tooltip="Disabled state"
                />
            </div>
            <div className="demoBox">
                <h2>ToggleSwitch</h2>

                <ToggleSwitch
                    name="toggleDemo1"
                    checked={states.toggleDemo1}
                    ariaLabel="Toggle off/on"
                    changeFn={(checked) => handleSelect(checked, 'toggleDemo1')}
                />

                <ToggleSwitch
                    name="toggleDemo2"
                    checked={states.toggleDemo2}
                    ariaLabel="Toggle checked"
                    changeFn={(checked) => handleSelect(checked, 'toggleDemo2')}
                />

                <ToggleSwitch
                    name="toggleDemo3"
                    checked={false}
                    disabled
                    ariaLabel="Toggle disabled"
                />

                <ToggleSwitch
                    name="toggleDemo4"
                    checked={true}
                    disabled
                    ariaLabel="Toggle disabled checked"
                />
            </div>
            <div className="demoBox">
                <h2>Knobs</h2>

                <KnobField size="sm"/>
                <KnobField/>
                <KnobField size="lg"/>
                <KnobField
                    size="lg"
                    class="generalVolume"
                    value={60}
                    name="timelineVolume"
                    min={0}
                    max={100}
                    changeFn={() => {}}
                />

            </div>
            <div className="demoBox">
                <h2>Buttons</h2>

                <ButtonFlat onClick={() => {}}>
                    {__('Crea progetto!', 'soundbetween')}
                </ButtonFlat>
                <ButtonFlat size="lg" onClick={() => {}}>
                    {__('Crea progetto!', 'soundbetween')}
                </ButtonFlat>
                <ButtonFlat size="lg" onClick={() => {}} disabled={true}>
                    {__('Crea progetto!', 'soundbetween')}
                </ButtonFlat>

                <ButtonFlatAccent size="md" onClick={() => {}}>Accent md</ButtonFlatAccent>
                <ButtonFlatAccent size="lg" onClick={() => {}}>Accent lg</ButtonFlatAccent>
                <ButtonFlatAccent size="md" ghost onClick={() => {}}>Accent ghost md</ButtonFlatAccent>
                <ButtonFlatAccent size="lg" ghost onClick={() => {}}>Accent ghost lg</ButtonFlatAccent>

                <ButtonFlatWarning size="md" onClick={() => {}}>Warning md</ButtonFlatWarning>
                <ButtonFlatWarning size="lg" onClick={() => {}}>Warning lg</ButtonFlatWarning>
                <ButtonFlatWarning size="md" ghost onClick={() => {}}>Warning ghost md</ButtonFlatWarning>
                <ButtonFlatWarning size="lg" ghost onClick={() => {}}>Warning ghost lg</ButtonFlatWarning>

                <ButtonOutline size="sm" onClick={() => {}}>Outline sm</ButtonOutline>
                <ButtonOutline size="md" onClick={() => {}}>Outline md</ButtonOutline>
                <ButtonOutline size="lg" onClick={() => {}}>Outline lg</ButtonOutline>
                <ButtonOutline size="md" onClick={() => {}} disabled={true}>Outline disabled</ButtonOutline>

                <Button3d
                    changeFn={() => handleToggle('btn3d')}
                    name="music"
                    checked={states.btn3d}>
                    {__('SoundBetween', 'soundbetween')}
                </Button3d>

                <ButtonIconRadioFlat
                    onChange={() => handleToggle('btnIcon1')}
                    value="music"
                    isSquare={true}
                    checked={states.btnIcon1}>
                    <PinIcon/>
                </ButtonIconRadioFlat>

                <ButtonIconRadioFlat
                    onChange={() => handleToggle('btnIcon1')}
                    value="music"
                    checked={states.btnIcon1}>
                    <PinIcon/>
                </ButtonIconRadioFlat>

                <ButtonIconRadio
                    onChange={() => handleToggle('btnIcon1')}
                    value="music"
                    checked={states.btnIcon1}>
                    <PinIcon/>
                </ButtonIconRadio>

                <ButtonIconRadio
                    onChange={() => handleToggle('btnIcon1')}
                    value="music"
                    isSquare={true}
                    checked={states.btnIcon1}>
                    <PinIcon/>
                </ButtonIconRadio>

                <ButtonIconFlat onClick={() => {}}>
                    <HamburgerIcon/>
                </ButtonIconFlat>

                <ButtonFormSubmit onClick={() => {}}>
                    {__('Confirm', 'soundbetween')}
                </ButtonFormSubmit>

                <ButtonFormSubmit onClick={() => {}} disabled={true}>
                    {__('Confirm', 'soundbetween')}
                </ButtonFormSubmit>
            </div>
            <div className="demoBox">
                <h2>Badges</h2>

                <Badge>24H</Badge>

                <Badge isActive={true}>48H</Badge>

                <Badge>72H</Badge>
            </div>
            <div className="demoBox">
                <h2>Project cards</h2>

                <ul className="projectCards" style={{maxWidth: 1200}}>
                    {demoProjects.map(o => (
                        <ProjectCard key={o.id} project={o} onOpen={() => {}}/>
                    ))}
                </ul>
            </div>
            <div className="demoBox">
                <h2>Dropdowns</h2>

                <div style={{width: 200}}>
                <DropdownWithSearch
                    emptyLabel="Choose a project"
                    value={states.dropdownWithSearch1}
                    selectFn={(value) => handleSelect(value, 'dropdownWithSearch1')}
                    options={[
                        {value: 1, label: 'Project A'},
                        {value: 2, label: 'Project B'},
                        {value: 3, label: 'Project C'}
                    ]}/>
                </div>

                <div style={{width: 200}}>
                    <DropdownWithSearch
                        emptyLabel="Choose a project"
                        value={states.dropdownWithSearch2}
                        selectFn={(value) => handleSelect(value, 'dropdownWithSearch2')}
                        searchFn={() => {}}
                        options={[
                            {value: 1, label: 'Project A'},
                            {value: 2, label: 'Project B'},
                            {value: 3, label: 'Project C'}
                        ]}/>
                </div>
            </div>
            <div className="demoBox">
                <h2>Sliders</h2>

                <SliderField
                    value={states.slider1}
                    min={0}
                    max={100}
                    name="slider1"
                    step={2}
                    changeFn={handleSelect}
                />

                <span style={{color: '#BDCCDE'}}>{states.slider1}</span>
            </div>
            <div className="demoBox">
                <h2>Form and form fields</h2>

                <div style={{width: 400}}>
                    <form className="appForm">
                        <fieldset>
                            <FormField
                                type="text"
                                name="email"
                                placeholder={__('Email', 'soundbetween')}
                                control={control}
                            />

                            <FormField
                                type="password"
                                name="password"
                                placeholder={__('Password', 'soundbetween')}
                                errors={['Error message']}
                                control={control}
                            />

                            <FormField
                                type="text"
                                name="title"
                                label={__('Titolo', 'soundbetween')}
                                placeholder={__('Digita nome progetto', 'soundbetween')}
                                control={control}
                                config={{ required: __('È obbligatorio', 'soundbetween') }}
                            />

                            <FormField
                                type="datepicker"
                                name="endDate"
                                label={__('Deadline', 'soundbetween')}
                                placeholder={__('', 'soundbetween')}
                                control={control}
                                rules={{ required: __('È obbligatorio', 'soundbetween') }}
                            />

                            <FormField
                                type="numeric"
                                name="budget"
                                label={__('Budget', 'soundbetween')}
                                placeholder="0.00"
                                prefix="€"
                                control={control}
                                rules={{
                                    required: 'Price is required',
                                    pattern: {
                                        value: /^-?\d+(\.\d{1,2})?$/,
                                        message: 'Please enter a valid price with up to 2 decimal places'
                                    }
                                }}
                            />

                            <FormField
                                type="fileupload"
                                name="image"
                                label={__('Immagine di copertina', 'soundbetween')}
                                placeholder={__('Scegli un file', 'soundbetween')}
                                control={control}
                                accept="image/*"
                                rules={{ required: __('È obbligatorio', 'soundbetween') }}
                            />

                            <FormField
                                type="checkbox"
                                name="privacy"
                                label={sprintf(
                                    __('I agree to %s and %s', 'soundbetween'),
                                    `<a href="">${__('Terms of Service')}</a>`,
                                    `<a href="">${__('Privacy Policy')}</a>`
                                )}
                                control={control}
                            />
                        </fieldset>

                        <ButtonFormSubmit onClick={() => {}}>
                            {__('Confirm', 'soundbetween')}
                        </ButtonFormSubmit>

                        <ButtonFormSubmit onClick={() => {}} disabled={true}>
                            {__('Confirm (disabled)', 'soundbetween')}
                        </ButtonFormSubmit>
                    </form>
                </div>
            </div>
            <div className="demoBox">
                <h2>Switch Form Fields</h2>
                <div style={{width: 400}}>
                    <FormField type="switch" name="switchDemo1"
                        label={__('Notifiche Email', 'soundbetween')}
                        description={__('Ricevi aggiornamenti via email', 'soundbetween')}
                        control={control} />
                    <FormField type="switch" name="switchDemo2"
                        label={__('Email Marketing', 'soundbetween')}
                        description={__('Novità, suggerimenti e offerte speciali', 'soundbetween')}
                        control={control} />
                    <FormField type="switch" name="switchDemo3"
                        label={__('Notifiche Push', 'soundbetween')}
                        description={__('Disabilitato — stato disabled', 'soundbetween')}
                        control={control}
                        disabled />
                </div>
            </div>
            <div className="demoBox">
                <h2>Panels</h2>

                <WorkbenchPanel>
                    <p>Some content</p>
                </WorkbenchPanel>
            </div>
            <div className="demoBox">
                <h2>Fileupload Drop zone</h2>

                <div style={{width: 200, height: 180}}>
                    <FileuploadDropZone />
                </div>
            </div>
            <div className="demoBox">
                <h2>Comm Center — Projects feed</h2>

                <div className="appDashboard" style={{height: 760}}>
                    <CommCenterProjects/>
                </div>
            </div>
            <div className="demoBox">
                <h2>Comm Center — project sidebar (Attività / Comunicazioni / Brief)</h2>

                <div className="appDashboard" style={{height: 760}}>
                    <CommCenter
                        cueTarget="cuesheet"
                        briefFallback={MOCK_BRIEF}
                        hasBrief/>
                </div>
            </div>
        </div>
    )
}

export default DevComponents;